import React, { useState, useEffect } from 'react';
import {
  Platform,
  StatusBar,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  ImageBackground
} from "react-native";

import AsyncStorage from '@react-native-async-storage/async-storage';

import { COLORS, SIZES, IMAGES, FONTS } from '../constants';
import { useNavigation } from '@react-navigation/native';
import { MaterialIcons } from '@expo/vector-icons';

import { OutlineBtn, SolidBtn, RadioBtn } from "../components"

export default function DisciplinesScreen() {

  const navigation = useNavigation();
  const [isLoading, setIsLoading] = useState(true);

  const disciplinesData = require('../../assets/json/dyscypliny.json')

  const [competition1, setCompetition1] = useState();
  const [competition2, setCompetition2] = useState();
  const [competition3, setCompetition3] = useState();
  const [competition4, setCompetition4] = useState(disciplinesData[6].name);

  const [disciplinesInfo, setDisciplinesInfo] = useState();

  const saveDisciplines = async (props) => {
    // console.log(props)
    const disciplinesToSave = {
      d1: competition1,
      d2: competition2,
      d3: competition3,
      d4: competition4
    }

    try {
      if(props === 0 || props === 1){
        setCompetition1(disciplinesData[props].name)
        disciplinesToSave.d1 = disciplinesData[props].name
      } else if (props === 2 || props === 3) {
        setCompetition2(disciplinesData[props].name)
        disciplinesToSave.d2 = disciplinesData[props].name
      } else if (props === 4 || props === 5) {
        setCompetition3(disciplinesData[props].name)
        disciplinesToSave.d3 = disciplinesData[props].name
      }

      await AsyncStorage.setItem('@disciplines', JSON.stringify(disciplinesToSave));
      setDisciplinesInfo(disciplinesToSave);

    } catch (err) {
      // saving error
      console.log(err)
    }
  }

  const getData = async () => {
    try {
      const jsonValue = await AsyncStorage.getItem('@disciplines')
      // console.log(JSON.parse(jsonValue))

      setDisciplinesInfo(JSON.parse(jsonValue));

      setCompetition1(JSON.parse(jsonValue).d1);
      setCompetition2(JSON.parse(jsonValue).d2);
      setCompetition3(JSON.parse(jsonValue).d3);
      setCompetition4(JSON.parse(jsonValue).d4);

    } catch (e) {
      console.log("error", e)
    }

    console.log(JSON.stringify(disciplinesInfo))
    setIsLoading(false);
  }

  useEffect(() => {
    // AsyncStorage.clear();
    getData();
  }, []);

  if (isLoading) {
    return (
      <ImageBackground
        source={IMAGES.bg2}
        style={styles.bg}
      >
        <View style={styles.container}>
          <Text style={styles.titleText}>Pobieram dane...</Text>
        </View>
      </ImageBackground>
    );
  }

  return (

    <ImageBackground
      source={IMAGES.bg2}
      style={styles.bg}
    >

      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            {/* <Text
              style={styles.titleText}
            >
            Dyscypliny
            </Text> */}
            <Text
              style={styles.subtitleText}
            >
              wybierz swoje dyscypliny</Text>
          </View>

          <TouchableOpacity
            // onPress={() => alert("Ekran z definicjami")}
            onPress={() => navigation.navigate('Definitions')}

          >

            <View style={styles.headerRight}>
              <View style={styles.outlineBtn}>
                <Text style={styles.outlineBtnText}>
                  Definicje
                </Text>
              </View>
            </View>
          </TouchableOpacity>

        </View>

        <View style={styles.radioBtns}>
          <View style={styles.row}>
            <RadioBtn
              selected={competition1 === disciplinesData[0].name ? true : false}
              changeValue={() => {
                // setCompetition1(disciplinesData[0].name)
                saveDisciplines(disciplinesData[0].id);
              }}
              text={disciplinesData[0].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={competition1 === disciplinesData[1].name ? true : false}
              changeValue={() => {
                // setCompetition1(disciplinesData[1].name);
                saveDisciplines(disciplinesData[1].id);
              }}
              text={disciplinesData[1].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={competition2 === disciplinesData[2].name ? true : false}
              changeValue={() => {
                // setCompetition2(disciplinesData[2].name);
                saveDisciplines(disciplinesData[2].id);
              }}
              text={disciplinesData[2].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={competition2 === disciplinesData[3].name ? true : false}
              changeValue={() => {
                // setCompetition2(disciplinesData[3].name);
                saveDisciplines(disciplinesData[3].id);
              }}
              text={disciplinesData[3].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={competition3 === disciplinesData[4].name ? true : false}
              changeValue={() => {
                // setCompetition3(disciplinesData[4].name)
                saveDisciplines(disciplinesData[4].id);
              }}
              text={disciplinesData[4].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={competition3 === disciplinesData[5].name ? true : false}
              changeValue={() => {
                // setCompetition3(disciplinesData[5].name)
                saveDisciplines(disciplinesData[5].id);
              }}
              text={disciplinesData[5].name}
            />
          </View>

          <View style={styles.row}>
            <RadioBtn
              selected={true}
              text={competition4}
            />
          </View>
        </View>

      </View>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    // backgroundColor: COLORS.background,
    padding: SIZES.padding,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    alignItems: 'flex-start',
  },
  headerLeft: {
    // width: '60%',
    paddingTop: 0
  },
  headerRight: {
    paddingTop: 0
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle
  },
  outlineBtn: {
    backgroundColor: COLORS.background,
    borderColor: COLORS.secondary,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 30,
  },
  outlineBtnText: {
    color: COLORS.primary,
    fontSize: 12
  },
  bg: {
    width: "100%",
    height: "100%"
  },
  radioBtns: {
    // flex: 1,
    marginTop: 10,
  },
  row: {
    marginBottom: 24,
  }
});